import {
  globalPostService,
  globalGetService,
  globalPutService,
  globalDeleteService,
} from '../../../utils/globalApiServices';
import apiInstance from '../../../utils/apiInterceptor';
import { getTimezone } from '../../../utils/time';

export function getBrandsList() {
  globalGetService('csp/brands', { recordsPerPage: 1000 }).then((response) => {
    if (response.status >= 200 && response.status < 300) {
      this.setState({
        loader: false,
        brands: response.data.records,
      });
    }
  });
}

export function getCampaignPrimaryDcaApi(campaignUid) {
  globalGetService(`csp/campaigns/${campaignUid}/primaryDca`).then(
    (response) => {
      if (response.status >= 200 && response.status < 300) {
        const dcaInfo = response.data;
        this.setState({ dcaInfo });
      }
    }
  );
}

export function getCampaignOfferingsbyBrand(brandId) {
  return globalGetService(`csp/campaign-requests/builder/brand/${brandId}`);
}
export function getListOfCampaignUsecases() {
  globalGetService(`enums/usecaseTypes`).then((response) => {
    if (response.status >= 200 && response.status < 300) {
      this.setState({
        usecases: response.data,
      });
    }
  });
}
export function registerSubscription(campaignRequestId) {
  return globalPostService('csp/payment/subscription', campaignRequestId);
}

export function findAllVerticalTypes(flag) {
  if (flag == 'filter') {
    return globalGetService('enums/verticalTypes');
  } else {
    globalGetService('enums/verticalTypes').then((response) => {
      if (response.status >= 200 && response.status < 300) {
        this.setState((prevState) => ({
          ...prevState,
          verticalTypes: response.data,
        }));
      }
    });
  }
}
export function getListOfBrandUsecases(brandUid) {
  globalGetService(`csp/campaign/builder/brand/${brandUid}`).then(
    (response) => {
      if (response.status >= 200 && response.status < 300) {
        const brandUsecases = response.data;
        this.setState((prevState) => ({
          ...prevState,
          brandUsecases,
        }));
        const { usecase } = this.state;
        if (usecase && usecase.id) {
          const selectedUsecase = brandUsecases.find(
            (item) => item.usecase == usecase.id
          );
          let qualify = false;
          if (selectedUsecase && selectedUsecase.mnoMetadata) {
            qualify = Object.keys(selectedUsecase.mnoMetadata).some(
              (key) => selectedUsecase.mnoMetadata[key].qualify === true
            );
          }
          if (!qualify) {
            this.handleChange('', 'usecase');
          }
        }
      }
    }
  );
}
export function findAllBrands() {
  return globalGetService('csp/brands', { recordsPerPage: 1000 });
}
export function buildCampaignRequest(brandUid, usecase) {
  globalGetService(
    `csp/campaign/builder/brand/${brandUid}/usecase/${usecase}`
  ).then((response) => {
    this.setState({ loadFlag: false });
    if (response.status >= 200 && response.status < 300) {
      const mnoInfo = response.data;
      if (mnoInfo.mnoMetadata) {
        const flag = Object.keys(mnoInfo.mnoMetadata).find((key, index) => {
          return mnoInfo.mnoMetadata[key].qualify === true;
        });
        this.setState((prevState) => ({
          ...prevState,
          mnoInfo,
          // activeMno : flag ? mnoInfo.mnoMetadata[flag] : {},
          mnoStatusFlag: flag ? true : false,
          step: 2,
          openDisclaimer: true,
          campaignInfo: {
            ...prevState.campaignInfo,
            mnoIds: Object.keys(mnoInfo.mnoMetadata)
              .map((key) => mnoInfo.mnoMetadata[key].qualify && key)
              .filter((val) => val !== false),
          },
        }));
      }
    }
  });
}
export function getCampaignOperationStatusApi(campaignUid) {
  globalGetService(`csp/campaigns/${campaignUid}/operationStatus`).then(
    (response) => {
      if (response.status >= 200 && response.status < 300) {
        this.setState((prevState) => ({
          ...prevState,
          mnoStatusInfo: response.data,
        }));
      }
    }
  );
}

export function getAllDcaApi() {
  globalGetService(`csp/dca`, { recordsPerPage: 1000 }).then((response) => {
    if (response.status >= 200 && response.status < 300) {
      const dca = response.data.records;
      this.setState({
        dca,
      });
    }
  });
}
export function fetchAllResellers() {
  return globalGetService(`csp/reseller`, { recordsPerPage: 1000 });
}
export function getAllResellers() {
  fetchAllResellers().then((response) => {
    if (response.status >= 200 && response.status < 300) {
      const resellers = response.data.records;
      this.setState({
        resellers,
      });
    }
  });
}

export function nominateCnpApi(campaignUid, upstreamCnpUid) {
  return globalPutService(
    `csp/campaigns/sharedByMe/${campaignUid}/with/${upstreamCnpUid}`
  );
}

export function rejectCnpNominationApi(campaignUid, explanation) {
  return globalDeleteService(`csp/campaigns/sharedWithMe/${campaignUid}`, {
    explanation,
  });
}

export function listCampaignElectedDcaApi(campaignUid, params) {
  return globalGetService(`csp/campaigns/${campaignUid}/mnoIds`, params).then(
    (response) => {
      if (response.status >= 200 && response.status < 300) {
        return response.data;
      }
      return [];
    }
  );
}

export function getNominationStatusApi(campaignUid, params) {
  return globalGetService(
    `csp/campaigns/sharedByMe/${campaignUid}`,
    params
  ).then((response) => {
    if (response.status >= 200 && response.status < 300) {
      const nominationInfo = response.data ? response.data : {};
      return {
        nominationInfo,
        openAlert: nominationInfo.status
          ? ['DECLINED'].includes(nominationInfo.status)
            ? true
            : false
          : true,
      };
    }
  });
}

export const uploadAttachmentApi = async (file) => {
  const data = new FormData();
  data.append('file', file);
  const response = await globalPostService('csp/attachments', data);
  if (response.status >= 200 && response.status < 300) {
    return response.data;
  }
};

export const uploadAttachmentForCampaignApi = async (
  campaignUid,
  folder,
  file
) => {
  const data = new FormData();
  data.append('file', file);
  const response = await globalPostService(
    `csp/attachments/campaign/${campaignUid}/folder/${folder}`,
    data
  );
  if (response.status >= 200 && response.status < 300) {
    return response.data;
  }
};

export const deleteAttachmentApi = async (attachmentUuid) => {
  const response = await globalDeleteService(
    `csp/attachments/delete?attachmentUuid=${encodeURIComponent(
      attachmentUuid
    )}`
  );
  return !!response?.ok;
};

export const getCampaignAttachmentsApi = async (campaignUid, folder) => {
  const response = await globalGetService(
    `csp/attachments/campaign/${campaignUid}?folder=${encodeURIComponent(
      folder
    )}`
  );
  if (response.status >= 200 && response.status < 300) {
    return response.data;
  }
  return [];
};

export const downloadAttachmentApi = async (attachmentUuid) => {
  const response = await globalGetService(
    `csp/attachments/download?attachmentUuid=${encodeURIComponent(
      attachmentUuid
    )}`,
    {},
    'arraybuffer'
  );
  if (response.status >= 200 && response.status < 300) {
    return response.data;
  }
};

export const downloadAttachmentToDesktop = async (attachmentUuid, fileName) => {
  const response = await globalGetService(
    `csp/attachments/download?attachmentUuid=${encodeURIComponent(
      attachmentUuid
    )}`,
    {},
    'blob'
  );
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();

  // Clean up and remove the link
  link.parentNode.removeChild(link);
};

export const submitCampaignRequest = async (brandUid, usecase, data) => {
  const { upstreamCnpUid, ...parameters } = data;
  const response = await globalPostService(
    `csp/campaign/builder/brand/${brandUid}/usecase/${usecase}`,
    parameters
  );
  if (response.status >= 200 && response.status < 300) {
    try {
      await globalPutService(
        `csp/campaigns/sharedByMe/${response.data.campaignUid}/with/${upstreamCnpUid}`,
        parameters
      );
    } catch (e) {}
    return response.data;
  }
};

export const getProfile = async () => {
  const response = await globalGetService('csp/profile');
  if (response.status >= 200 && response.status < 300) {
    return response.data;
  }
  throw new Error('API error');
};

export const getCampaignTermsAndConditions = async () => {
  const response = await globalGetService(
    'csp/campaign/builder/termsAndConditions'
  );
  if (response.status >= 200 && response.status < 300) {
    return response.data.subTerms;
  }
  return [];
};

export const getEventHistory = async (query = {}) => {
  const response = await globalGetService('csp/event', {
    ...query,
    sortField: 'createDate',
    ascendingOrder: false,
  });
  if (response && response.status >= 200 && response.status < 300) {
    const eventInfo = response.data;
    eventInfo.recordsPerPage = eventInfo.recordsPerPage
      ? eventInfo.recordsPerPage
      : 10;
    return eventInfo;
  }
};

export const nudgeUpstreamCnp = async (campaignUid, intent, description) => {
  const response = await globalPostService(
    `csp/campaigns/${campaignUid}/nudge`,
    {
      intent,
      description,
    }
  );
  if (response.status >= 200 && response.status < 300) {
    return response.data;
  }
  throw new Error('Unexpected API error');
};

export const getBuilderInfo = async (brandUid, usecase) => {
  const response = await globalGetService(
    `csp/campaign/builder/brand/${brandUid}/usecase/${usecase}`
  );
  if (response.status >= 200 && response.status < 300) {
    return response.data;
  }
  throw new Error('Unexpected API error');
};

export const resubmitCampaign = async (campaignUid, mnoIds) => {
  const response = await globalPutService(
    `csp/campaigns/${campaignUid}/resubmit?${mnoIds
      .map((mnoId) => `mnoIds=${mnoId}`)
      .join('&')}`
  );
  if (response.status >= 200 && response.status < 300) {
    return response.data;
  }
  throw new Error('Unexpected API error');
};

export const getMnoList = async () => {
  const response = await globalGetService('enums/mno');
  if (response.status >= 200 && response.status < 300) {
    return response.data;
  }
  throw new Error('Unexpected API error');
};

export const updateCampaign = async (campaignUid, data) => {
  const response = await globalPutService(`csp/campaigns/${campaignUid}`, data);
  if (response.status >= 200 && response.status < 300) {
    return response.data;
  }
  throw new Error('Unexpected API error');
};

export const queryCampaignPhoneNumbers = async (campaignUid, query = {}) => {
  const response = await apiInstance.get(
    `csp/campaigns/${campaignUid}/phoneNumbers`,
    {
      params: query,
      validateStatus: null,
    }
  );
  if (response.status >= 200 && response.status < 300) {
    return response.data;
  }
  return null;
};

export const getCampaignPhoneNumbersOnly = async (campaignUid, query = {}) => {
  const response = await globalGetService(
    `csp/campaigns/${campaignUid}/phoneNumbersOnly`,
    query
  );
  if (response.status >= 200 && response.status < 300) {
    return response.data;
  }
  return null;
};

export const downloadCampaignPhoneNumbers = async (campaignUid, query = {}) => {
  const response = await globalGetService(
    `csp/campaigns/${campaignUid}/phoneNumbers/csv`,
    { ...query, timezone: getTimezone() },
    'arraybuffer'
  );
  if (response && response.status >= 200 && response.status < 300) {
    return response.data;
  }
  return null;
};

export const getCampaignRoles = async (campaignUid) => {
  try {
    const response = await globalGetService(
      `csp/campaigns/${campaignUid}/roles`
    );
    if (response.ok) return response.data;
    return null;
  } catch {
    return null;
  }
};

export const getMigrationCNP = async (campaignUid, params, configs = {}) => {
  const { silent = false } = configs;
  try {
    const response = await apiInstance.get(
      `csp/campaigns/${campaignUid}/migrateCnp`,
      {
        params,
        validateStatus: silent ? null : undefined,
      }
    );

    if (response.ok) {
      return response.data;
    }
    return null;
  } catch {
    return null;
  }
};

/** START -- new methods for CampaignDetailV2 to decouple this.setState() from api calls */
export async function fetchCampaignDetails(campaignUid, params) {
  const response = await globalGetService(
    `csp/campaigns/${campaignUid}`,
    params
  );
  if (response?.ok) {
    const campaign = response.data;
    return {
      campaign,
      optinKeywords: campaign.optinKeywords
        ? campaign.optinKeywords.split(',')
        : [],
      optinMessage: campaign.optinMessage || '',
      optoutKeywords: campaign.optoutKeywords
        ? campaign.optoutKeywords.split(',')
        : [],
      optoutMessage: campaign.optoutMessage || '',
      helpKeywords: campaign.helpKeywords
        ? campaign.helpKeywords.split(',')
        : [],
      helpMessage: campaign.helpMessage || '',
      embeddedLinkSample: campaign.embeddedLinkSample || '',
    };
  }
}

export async function fetchResellerDetail(resellerUid) {
  const response = await globalGetService(`csp/reseller/${resellerUid}`);
  if (response?.ok) {
    return response.data;
  }
}

export async function getCampaignOperations(
  campaignUid,
  queries = {},
  configs = {}
) {
  return globalGetService(
    `csp/campaigns/${campaignUid}/operations`,
    queries,
    configs
  ).then((response) => {
    if (response?.ok) {
      const mnoStatusInfo = response.data.records;
      mnoStatusInfo.forEach((item) => {
        item.rulesEngineResultsJson = JSON.parse(item.rulesEngineResultsJson);
        item.osrAttributesJson = JSON.parse(item.osrAttributesJson);
      });
      return mnoStatusInfo;
    }
  });
}

export async function deactivateCampaign(campaignUid, currentCampaign) {
  return globalPutService(`csp/campaigns/${campaignUid}/deactivate`).then(
    (response) => {
      if (response?.ok) {
        const campaign = response.data;
        campaign.brandName = currentCampaign.brandName || '';
        return campaign;
      } else {
        throw new Error('Failed to deactivate campaign');
      }
    }
  );
}
/** END */
